import type { RefObject } from 'react';
import type { View } from 'react-native';

export interface TutorialTargetRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export type TutorialOverlayPlacement = 'above' | 'below' | 'centered';

export interface TutorialOverlayPadding {
  paddingHorizontal?: number;
  paddingVertical?: number;
}

export type TutorialTargetRef = RefObject<View | null>;

export interface TutorialTargetRegistration {
  id: string;
  isFocused: boolean;
  ref: TutorialTargetRef;
}

export type TutorialTargetRegistrations = Partial<Record<TutorialRef, TutorialTargetRegistration[]>>;

export enum Tutorial {
  PublishOffers = 'publishOffers',
  MultipleOffers = 'multipleOffers',
  ChatCreation = 'chatCreation',
  FirstConversation = 'firstConversation',
  FirstMessageSent = 'firstMessageSent',
  Conciergerie = 'conciergerie',
  HomeExplore = 'homeExplore',
  ContactMember = 'contactMember',
  ChatIntro = 'chatIntro',
}

export enum TutorialRef {
  PublishButton = 'publishButton',
  OffersButtons = 'offersButtons',
  SingleOfferButton = 'singleOfferButton',
  FirstOfferInList = 'firstOfferInList',
  FirstConciergeChat = 'firstConciergeChat',
  ChatInputField = 'chatInputField',
  SuggestDatesButton = 'suggestDatesButton',
  ChatCreationButton = 'chatCreationButton',
  HeaderSearchBar = 'headerSearchBar',
  HeaderHelpButton = 'headerHelpButton',
  ContactMemberButton = 'contactMemberButton',
  ChatIntroButton = 'chatIntroButton',
}

export interface TutorialOverlayProps {
  tutorial: Tutorial;
  title?: string;
  text?: string;
  pointing?: boolean;
  showNextCta?: boolean;
  isLastStep?: boolean;
  target?: TutorialTargetRef;
  targetRef?: TutorialRef;
  padding?: TutorialOverlayPadding;
  ownerRouteKey?: string;
  stepNumber?: number;
  totalSteps?: number;
}

export type ShowTutorialOverlayType = (
  tutorial: Tutorial,
  element?: TutorialTargetRef,
  title?: string,
  text?: string,
  showNextCta?: boolean,
  isLastStep?: boolean,
  padding?: TutorialOverlayPadding,
  targetRef?: TutorialRef,
  stepNumber?: number,
  totalSteps?: number,
  ownerRouteKey?: string,
) => void;

export interface StartTutorialOptions {
  /** ContactMember runs inside the listing modal — do not treat it as blocking. */
  allowListingModal?: boolean;
}
